export default __webpack_public_path__ + "navigation-examples-basic-thumbnail-480-78f9a3345dbb9921130eccc321a82edd.webp";